"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
//Move to ui-components package as needed
var classnames_1 = __importDefault(require("classnames"));
var InvoiceCard = function (props) {
    var children = props.children, additionalClasses = props.additionalClasses, key = props.key;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1["default"])('invoice-card', additionalClasses) }, { children: children }), key));
};
exports["default"] = InvoiceCard;
//# sourceMappingURL=invoice-card.js.map